/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export const LAZY_LOADER_TOKEN = new InjectionToken<{ [key: string]: string }>('LAZY_LOADER_TOKEN');
